module.exports = __webpack_public_path__ + "static/media/radiation_safety_plan_review_presentation.9778b34f.svg";